module.exports = _.pick;


//////////////////
// WEBPACK FOOTER
// external "_.pick"
// module id = 452
// module chunks = business-manager/video-library-page full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings